import { useTheme } from '../../contexts/ThemeContext';

const PartnersSlider = ({ partners }) => {
  const { darkMode } = useTheme();

  return (
    <div className="overflow-hidden py-4">
      <div
        className="flex items-center partners-slider"
        style={{
          gap: '10rem',
          width: 'max-content'
        }}
      >
        {/* Double the partners for seamless infinite loop */}
        {[...partners, ...partners, ...partners].map((partner, index) => (
          <div
            key={index}
            className="flex-shrink-0 p-2"
            style={{ minWidth: '180px' }}
          >
            <img
              src={partner.logo}
              alt={`${partner.name} logo`}
              className={`h-12 md:h-14 w-auto transition-all duration-150 mx-auto ${
                darkMode ? 'brightness-0 invert opacity-70 hover:opacity-100' : 'brightness-0 opacity-60 hover:opacity-100'
              }`}
              style={{
                // Very wide wordmarks set their own cap so they don't render shorter than the rest
                maxWidth: `${partner.maxWidth ?? 180}px`,
                objectFit: 'contain'
              }}
              onError={(e) => {
                // Fallback to text if image fails
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <span
              className={`hidden titleFont text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}
            >
              {partner.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnersSlider;
